import { styles } from '../../../renderers/node/nodeStyles';
export const getChildOffset = (amountOfOuts, position) => {
    const spacing = styles.base.width / amountOfOuts;
    return spacing * position - spacing / 2;
};
export const getChildStartX = (preCalculatedStartX) => preCalculatedStartX;
export const getChildStartY = (preCalculatedStartY) => preCalculatedStartY;
export const getChildEndX = (preCalculatedEndX) => 
/* End it in the center of child */
preCalculatedEndX + styles.base.width / 2;
export const getChildEndY = (preCalculatedEndY) => preCalculatedEndY;
